import React, { Component } from 'react';
import styles from './simpleMinimizedMail.module.scss';
import getLabel from './../../../../utils/labels'
import starredIcon from '../../../../globals/images/star_selected.png';
import attachmentIcon from '../../../../globals/images/attachment.svg';

class SimpleMinimizedMail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMailStarred: this.getMailStarredFlag(props.actionThread)
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            isMailStarred: this.getMailStarredFlag(nextProps.actionThread)
        })
    }

    getMailStarredFlag = (actionThread) => {
        return actionThread.some((action) => (action.type === "starred" && action.status === true));
    }

    getMinimizedBody = () => {
        return <div className={styles['body-text']}>{this.props.body.join(" ").replace(/<\/?[^>]+(>|$)/g, "")}</div>
    }

    getFromActor = () => {
        const { from, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === from) || actors.inActors.find(actor => actor.id === from);
        if (actorDetails) {
            return actorDetails
        }
        return from;
    }

    // getFromActor = () => {
    //     const { from, actors } = this.props;

    //     let actorDetails = actors.clients.find(actor => actor.id === from) || actors.inActors.find(actor => actor.id === from);
    //     if (actorDetails) {
    //         return actorDetails.first_name + ' ' + actorDetails.last_name
    //     }
    //     return from;
    // }

    render() {
        const { match, showReplyOption, type, attachments, isReply, displayTime } = this.props;
        const { isMailStarred } = this.state;

        let fromActor = this.getFromActor();

        return (
            <div className={styles.container} onClick={() => this.props.onMailClick()}>
                <div className={styles['icon-container']}>
                    <img src={fromActor.gravatar} className={styles.image} />
                </div>
                <div className={styles['content']}>
                    <header className={styles['header']}>
                        <div className={styles["people-container"]} >
                            <div className={styles['from']} >
                                {`${fromActor.first_name} ${fromActor.last_name}`}
                            </div>
                        </div>
                        {
                            !isReply ?
                                <div className={styles['action-list']}>
                                    {
                                        attachments ?
                                            <div className={styles.attachment}>
                                                <img src={attachmentIcon} />
                                            </div>
                                            : null
                                    }
                                    {
                                        isMailStarred ?
                                            <div className={styles.star}>
                                                <img src={starredIcon} />
                                            </div>
                                            :
                                            null
                                    }
                                    <div className={styles.timer}>
                                        {
                                            displayTime > 0 ?
                                                <div>{("0" + displayTime).slice(-2)} {getLabel('label_time_received_at')}</div>
                                                :
                                                <div>{getLabel('label_just_now')}</div>
                                        }
                                    </div>
                                </div>
                                :
                                null
                        }
                    </header>

                    <div className={styles.body}>
                        {this.getMinimizedBody()}
                    </div>
                </div>
            </div>
        )
    }
}

export default SimpleMinimizedMail;


// WEBPACK FOOTER //
// /src/components/mailThread/mail/simpleMinimizedMail/SimpleMinimizedMail.js